import { Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../../services/authentication.service';
var ProfilePasswordComponent = (function () {
    function ProfilePasswordComponent(apiService, router, authService, translate) {
        this.apiService = apiService;
        this.router = router;
        this.authService = authService;
        this.translate = translate;
        this.oldPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.errorMessage = null;
    }
    ProfilePasswordComponent.prototype.submit = function () {
        var _this = this;
        this.sniff('CHANGE_PASSWORD', '');
        this.errorMessage = null;
        if (this.translate.currentLang !== 'en') {
            if (this.newPassword.length === 0) {
                this.errorMessage = 'โปรดกรอกรหัสผ่าน';
            }
            else {
                if (this.confirmPassword !== this.newPassword) {
                    this.errorMessage = 'รหัสผ่านไม่ตรงกัน';
                }
                else {
                    this.apiService.updatePassword({
                        old_password: this.oldPassword,
                        new_password: this.newPassword
                    }).subscribe(function () { return _this.router.navigate(['']); }, function (error) {
                        _this.checkErrorMsg(error);
                    });
                }
            }
        }
        else {
            if (this.newPassword.length === 0) {
                this.errorMessage = 'Please fill Password';
            }
            else if (this.confirmPassword !== this.newPassword) {
                this.errorMessage = 'Passwords do not match.';
            }
            else {
                this.apiService.updatePassword({
                    old_password: this.oldPassword,
                    new_password: this.newPassword
                }).subscribe(function () {
                    localStorage.removeItem('require_to_change_password');
                    if (_this.authService.isAccountant()) {
                        _this.router.navigate(['/search']);
                    }
                    else {
                        _this.router.navigate(['']);
                    }
                }, function (error) {
                    _this.checkErrorMsg(error);
                });
            }
        }
    };
    ProfilePasswordComponent.prototype.checkErrorMsg = function (error) {
        this.errorMessage = this.apiService.getErrorMessage(error, ' ');
    };
    ProfilePasswordComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'CHANGE_PASS',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    return ProfilePasswordComponent;
}());
export { ProfilePasswordComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-password/profile-password.component.ts.pre-build-optimizer.js